import ProductoHijo from './ProductoHijo';
export default ProductoHijo;